module.exports = __webpack_public_path__ + "img/klass_logo.0b043839.png";